import { NVButton } from '@nv/basic-components'
import clsx from 'clsx'
import styles from './ModalFooter.module.scss'

export const ModalFooter = ({ btns = [] }) => {
  return (
    <div className={clsx(styles['container'], { [styles['singleBtn']]: btns.length === 1 })}>
      {btns.map((btn, index) => (
        <NVButton
          variant={btn.variant}
          key={index}
          height={50}
          classes={{ container: btn.isCancel ? styles['cancel-btn'] : styles['primary-btn'] }}
          onClick={btn.onClick}
          text={btn.text}
          disabled={btn.disabled}
        />
      ))}
    </div>
  )
}
